<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="950px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Utworzenie z kampanii: Wybrane produkty
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-data-table
                                :headers="headers"
                                :items="selectedProducts"
                                :mobile-breakpoint="0"
                                name="Buffer"
                                item-key="id"
                            >
                                <template #item.campaign="{item}">
                                    {{ item._campaign }}
                                </template>
                                <template #item.orderProductionNumber="{item}">
                                    {{ item.orderProductionNumber }}
                                </template>
                                <template #item.name="{item}">
                                    {{ item.name }}
                                </template>
                                <template #item.productType="{item}">
                                    {{ item.productType.name }}
                                </template>
                                <template #item.plannedSendDate="{item}">
                                    {{ formatDate(item.plannedSendDate) }}'
                                </template>
                                <template #item.amount="{item}">
                                    {{ item.amount }}
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Usuń z bufora"
                                                    v-on="on"
                                                    @click="removeFromBuffer(item)"
                                                >
                                                    <v-icon color="red">
                                                        mdi-close-box-multiple
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Usuń</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                                <template #no-data>
                                    Nie dodano żadnych produktów
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'BufferDialog',
    mixins: [
        dateFormatter,
        tooltipDelay,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        selectedProducts: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Kampania',
                    value: 'campaign',
                    sortable: false,
                },
                {
                    text: 'Zamówienie',
                    value: 'orderProductionNumber',
                    sortable: false,
                },
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Typ produktu',
                    value: 'productType',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Data wysyłki',
                    value: 'plannedSendDate',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Ilość',
                    value: 'amount',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                }
            ]
        }
    },
    methods: {
        removeFromBuffer(item) {
            this.$emit('remove-from-buffer', item)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
